const STATUS = {
  COMPLETED: 'completed',
  ACTIVE: 'active',
  FUTURE: 'future',
  DISABLED: 'disabled'
};
const LABEL_PLACEMENT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};

export { LABEL_PLACEMENT as L, STATUS as S };
//# sourceMappingURL=constants-da6fc461.js.map
